export const environment = {
  // ==========================================
  // CONFIGURACIÓN GENERAL
  // ==========================================
  production: false,
  version: '3.0.0',

  // ==========================================
  // CONFIGURACIÓN DE API (TST)
  // ==========================================
  apiBaseUrl: 'https://sign-rse.tst.certicamara.com:8050',
  /**
   * Canal de origen para auditoría BFF (obligatorio en /api/sign/* y /api/audit/sign).
   * El BFF lo normaliza a mayúsculas.
   */
  originChannel: 'CERTITOOL WEB',
  /** Endpoint de certificados (Token Virtual). */
  certificatesApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/certificates',
  /** Endpoint de firma PDF (Token Virtual) JSON Base64. */
  signPdfApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/sign/pdf',
  /** Endpoint de firma PDF (Token Virtual) multipart binario. */
  signPdfMultipartApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/sign/pdf/multipart',
  /** Endpoint de firma PDF con certificado PFX/P12 JSON Base64. */
  signPdfPfxApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/sign/pdf/pfx',
  /** Endpoint de firma PDF PFX/P12 multipart binario. */
  signPdfPfxMultipartApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/sign/pdf/pfx/multipart',
  /** Endpoint de firma CAdES (Token Virtual) JSON Base64. */
  signCadesApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/sign/cades',
  /** Endpoint de firma CAdES (Token Virtual) multipart binario. */
  signCadesMultipartApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/sign/cades/multipart',
  /** Endpoint de firma CAdES con certificado PFX/P12 JSON Base64. */
  signCadesPfxApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/sign/cades/pfx',
  /** Endpoint de firma CAdES PFX/P12 multipart binario. */
  signCadesPfxMultipartApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/sign/cades/pfx/multipart',
  /** Endpoint de verificación JSON Base64. */
  verifyDocumentApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/verify/document',
  /** Endpoint de verificación multipart binario. */
  verifyDocumentMultipartApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/verify/document/multipart',
  /** Extrae el documento original de un CAdES attached. */
  verifyDownloadOriginalApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/verify/download-original',
  /** BFF firma RSE (Certitool Back → Sign_RSE). Ambiente TST. */
  signRseProcessesBaseUrl: 'https://sign-rse.tst.certicamara.com:8050/api/sign/rse/processes',
  /** Base Sign_RSE TST (solo para completar callback en modo stub). */
  signRseStubBaseUrl: 'https://ventaservice.tst.certicamara.com:9095',
  /** Extensión CADES en descarga vía Sign_RSE (p7m estándar | p7z entidad). */
  signRseCadesOutputExtension: 'p7z',
  signRsePollIntervalMs: 2000,
  signRsePollTimeoutMs: 300000,
  sendMailApiUrl: 'https://sign-rse.tst.certicamara.com:8050/api/mail/enviar',
  defaultLinkFirma: 'https://certitoolweb.tst.certicamara.com/certitool',

  // ==========================================
  // RUTAS EXTERNAS
  // ==========================================
  canalVentas: 'https://ventadigital.certicamara.com/',

  // ==========================================
  // AGENTE LOCAL / COMPLEMENTO (Token físico)
  // ==========================================
  /**
   * true = muestra token físico y hace health a localAgentBaseUrl/health.
   * false = oculta token físico y no llama al agente (release sin TF).
   */
  tokenFisicoEnabled: false,
  /** URL base del agente local (health, certificados, firma). */
  localAgentBaseUrl: 'http://localhost:28765',
  /** Timeout en ms para el health check del agente. */
  localAgentHealthTimeout: 5000,
  /** Intervalo en ms del polling de disponibilidad del agente. */
  localAgentHealthPollMs: 60000,
  /**
   * URL de descarga del complemento (instalador o ejecutable).
   * En pruebas puede ser una ruta local; en producción usar una URL https.
   */
  agentDownloadUrl: 'C:\\Users\\andrey.rodriguez\\Documents\\repositorios\\CertifirmaAgent\\bin\\Release\\net10.0\\win-x64\\CertifirmaAgent.exe',
  /** Etiquetas del complemento local (UI token físico). */
  agentDisplayName: 'CertiTool Agent',
  agentReleaseLabel: 'BETA OFICIAL v1.0',
  agentChecksumSha256: '',
  agentFisicoSignPdfPath: '/api/sign/fisico/pdf',
  agentFisicoSignCadesPath: '/api/sign/fisico/cades',
  cipher: 'jnKk0Pz+QT91oryaFPJaryg3yNJ9GA3zbvegflf6H89X1eD/61xVEc4q2U/wlF09' as string,
  /**
   * Restablecer PIN – Obtener número móvil por SERIALNUMBER del certificado.
   * Vacío = endpoint aún no configurado.
   */
  resetPinGetMobileBySerialUrl: '',

  // ==========================================
  // RESTABLECER CONTRASEÑA / DESCARGA / GESTIÓN (TST)
  // ==========================================
  /** Base del servicio de certificados (reset password + obtener certificado). */
  certificadoServiceUrl: 'https://ventaservice.tst.certicamara.com:5051',
  /** Orden de pedido (consultar / hidratar descarga). */
  ordenPedidoServiceUrl: 'https://ventaservice.tst.certicamara.com:4040',
  /** Gateway OTP por correo (descarga certificado). */
  otpGatewayUrl: 'https://j942938lr5.execute-api.us-east-1.amazonaws.com/Stage/ws/rest/sendOTP',
  otpTokenHeader: 'Xx6kndiJhIBi9NXuvOnq7doCWv6qC4WfKZc0oUM3tmWJpR38NFZlu3/78mLTP0IhM8TIHBmV/d91rgRcXY/lBbv14F2SQUm3tjGJGkjlnPI=',
  mailOtp: 'operacion@certicamara.com',
  /** CCSW5 RSE (registro + login popup para emisión con código). */
  urlCcsw5: 'https://ccsw5rse.tst.certicamara.com',
  /**
   * Callback OAuth tras login CCSW5 (debe coincidir con URI registrada en RSE).
   * Vacío = se arma con el origin actual + /auth-callback (o /certitool/auth-callback).
   */
  ccsw5RedirectUri: 'https://certitoolweb.tst.certicamara.com/certitool/auth-callback',
  /** JoinKeys: unir .key + .cer → .pfx (mismo gateway AWS que Canal). */
  joinKeysUrl: 'https://w5gyxh8ayc.execute-api.us-east-2.amazonaws.com/dev/APPGenerate/JoinKeys',
  /** Estado del trámite (listar solicitudes). */
  estadoTramiteServiceUrl: 'https://ventaservice.tst.certicamara.com:5055',
  /** Descarga factura electrónica (gateway AWS; requiere Cognito). */
  descargaFacturaUrl: 'https://w5gyxh8ayc.execute-api.us-east-2.amazonaws.com/dev/descargaFactura',
  cognitoTokenUrl: 'https://certiportaldesarrollo.auth.us-east-2.amazoncognito.com/oauth2/token',
  cognitoClientId: '3enknt0msqh6g62g5v06vhdqh0',
  cognitoClientSecret: '1pf0f4timfnsr47keqergfmki7ngo76tnen53ed22oa2bl79pirp',
  cognitoScope: 'CerCentral/cercentral',
  /** Validación de identidad (preguntas reto) para revocación. */
  validacionIdentidadServiceUrl: 'https://ventaservice.tst.certicamara.com:4041',
  /** En TST se omite el reto (mismo criterio que Canal). En PRD debe ir en false. */
  omitirValidacionIdentidadRevocacion: true
};
